/**
 * @generated SignedSource<<7549b5a30e0034d54f5605ba1c1e32c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssetModelsOrderField = "CREATED_AT" | "NAME" | "MANUFACTURER_NAME" | "FAMILY_NAME" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type AssetModelsOrder = {
  direction: OrderDirection;
  field: AssetModelsOrderField;
};
export type GeneralAssetModelsPaginationQuery$variables = {
  after?: string | null;
  first: number;
  name?: string | null;
  orderBy?: AssetModelsOrder | null;
};
export type GeneralAssetModelsPaginationQueryVariables = GeneralAssetModelsPaginationQuery$variables;
export type GeneralAssetModelsPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GeneralAssetModelsTable_generalAssetModels">;
};
export type GeneralAssetModelsPaginationQueryResponse = GeneralAssetModelsPaginationQuery$data;
export type GeneralAssetModelsPaginationQuery = {
  variables: GeneralAssetModelsPaginationQueryVariables;
  response: GeneralAssetModelsPaginationQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderBy"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneralAssetModelsPaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "GeneralAssetModelsTable_generalAssetModels"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneralAssetModelsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GeneralAssetModelConnection",
        "kind": "LinkedField",
        "name": "generalAssetModels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneralAssetModelEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GeneralAssetModel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "family",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "manufacturer",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "orderBy",
          "name"
        ],
        "handle": "connection",
        "key": "GeneralAssetModelsList_generalAssetModels",
        "kind": "LinkedHandle",
        "name": "generalAssetModels"
      }
    ]
  },
  "params": {
    "cacheID": "8e33e110f68280c0df26aa498372d47e",
    "id": null,
    "metadata": {},
    "name": "GeneralAssetModelsPaginationQuery",
    "operationKind": "query",
    "text": "query GeneralAssetModelsPaginationQuery(\n  $after: String\n  $first: Int!\n  $name: String\n  $orderBy: AssetModelsOrder\n) {\n  ...GeneralAssetModelsTable_generalAssetModels_4DjD4v\n}\n\nfragment GeneralAssetModelsTable_generalAssetModels_4DjD4v on Query {\n  generalAssetModels(first: $first, after: $after, orderBy: $orderBy, name: $name) {\n    totalCount\n    pageInfo {\n      hasPreviousPage\n      hasNextPage\n      startCursor\n      endCursor\n    }\n    edges {\n      node {\n        id\n        createdAt\n        name\n        family {\n          __typename\n          id\n          name\n        }\n        manufacturer {\n          __typename\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ecdf70b1ffd2d1cf0248b1d826f42e7";

export default node;
